// extracted by mini-css-extract-plugin
export default {"canvasLeftCom":"canvasLeftCom_canvasLeftCom__lhc1F","sizeTips":"canvasLeftCom_sizeTips__Ni+zV"};